import React from 'react'
import Markdown from 'react-markdown'
interface Props {
  title: string
  subTitle: string
  text: string
  image: string
  list: [
    {
      title: string
    }
  ]
}

const Perks: React.FunctionComponent<Props> = ({ title, list }) => {
  return (
    <section className="Perks">
      <div className="px-[21px] pt-[100px] pb-[100px] md:pt-[122px] md:px-20 md:pb-[61px] xl:pb-[200px] lg:px-[15vw] text-green-100">
        <div className="flex flex-col justify-center max-w-screen-xl mx-auto ">
          <h1 className="mb-[53px] text-[2.125rem] font-ttHovesBold leading-bigTitle w-full lg:text-[4.5rem] lg:-tracking-[.005em] lg:px-0 lg:mb-[100px]">
            {title}
          </h1>
          <div className="w-full px-[21] font-ttHovesDemiBold leading-bigTitle lg:text-[2.125rem] lg:justify-self-center lg:px-4">
            <ul className="flex flex-col gap-y-14 lg:block">
              {list.map((item, i) => (
                <li
                  key={`PerksList_${i}`}
                  className="flex lg:mb-[100px] last:mb-0 last:underline lg:underline-offset-8"
                >
                  <img
                    alt={item.title}
                    src="/images/icon-star.svg"
                    className="object-cover w-5 h-5 mt-1 mr-2 lg:mt-3 lg:mr-6"
                  />
                  <Markdown className="__perk">{item.title}</Markdown>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Perks
